import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import InnerImageZoom from '../InnerImageZoom/InnerImageZoom';
import './styles.css';
import './React360Viewer.css';
import Growm360Viewer from '../Growm360Viewer/Growm360Viewer'

// const InnerImageZoom = lazy(() => import('../InnerImageZoom/InnerImageZoom'));
// const Growm360Viewer = lazy(() => import('../Growm360Viewer/Growm360Viewer'));

const ProductViewerComponent = ({productsS3Bucketname, productFolder, cloudFrontUrl, autoplayViewer, imageToShow, forceUpdate, 
  onClickZoom, productSettings, images360HD, aspectRatio, parentWidth, parentHeight, showRotationIconOnStartup, imagesCount=36, is180Pan=false}) => {

  const imagesBaseUrl = `${cloudFrontUrl}/${productFolder}/`;
  //const imagesBaseUrl = `https://${productsS3Bucketname}.s3.eu-west-2.amazonaws.com/${productFolder}/`;
  const [isZoomed, setIsZoomed] = useState(false);
  const [toggleZoomTimer, setToggleZoomTimer] = useState(false); // Extra toggle variable to delay zoom toggling to avoid zoom getting stuck
  const [currentImageUrl, setCurrentImageUrl] = useState(`${imagesBaseUrl}1.jpg`);
  const [currentHDImageUrl, setCurrentHDImageUrl] = useState(`${imagesBaseUrl}1_full.jpg`);
  const [lastImageIndex, setLastImageIndex] = useState(0);
  const lastImageIndexRef = useRef(lastImageIndex);
  const [lastOverrideIndex, setLastOverrideIndex] = useState(0);
  const lastOverrideIndexRef = useRef(lastOverrideIndex);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isReadyToAutoplay, setIsReadyToAutoplay] = useState(false);
  const [currentImageToShow, setCurrentImageToShow] = useState(imageToShow);
  const [imageElements, setImageElements] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hasUserClicked, setHasUserClicked] = useState(false);
  const [isMaxImageIndexReached, setIsMaxImageIndexReached] = useState(false);
  const isMaxImageIndexReachedRef = useRef(isMaxImageIndexReached);
  const [isMinImageIndexReached, setIsMinImageIndexReached] = useState(true);
  const isMinImageIndexReachedRef = useRef(isMinImageIndexReached);
  const isFirstRender = useRef(true);

  const toggleZoom = () => {
    onClickZoom(currentImageUrl);
    handleZoomToggle();
  }

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; 
    }

    setTimeout(() => {
      onClickZoom(currentImageUrl);
      handleZoomToggle();
    }, 100);
  }, [toggleZoomTimer])

  // useEffect(() => {
  //   if (isZoomed) {
  //     // Optionally add a delay if needed:
  //     const timeoutId = setTimeout(() => {
  //       const imageElement = document.querySelector('.innerImageZoom img'); 
  //       if (imageElement) {
  //         const touchStartEvent = new TouchEvent('touchstart', {
  //           bubbles: true,
  //           cancelable: true,
  //           touches: [new Touch({
  //             identifier: Date.now(),
  //             target: imageElement,
  //             clientX: imageElement.getBoundingClientRect().left,
  //             clientY: imageElement.getBoundingClientRect().top
  //           })]
  //         });
  
  //         const touchEndEvent = new TouchEvent('touchend', {
  //           bubbles: true,
  //           cancelable: true,
  //           touches: [],
  //           changedTouches: [new Touch({
  //             identifier: Date.now(),
  //             target: imageElement,
  //             clientX: imageElement.getBoundingClientRect().left,
  //             clientY: imageElement.getBoundingClientRect().top
  //           })]
  //         });
  
  //         imageElement.dispatchEvent(touchStartEvent);
  //         imageElement.dispatchEvent(touchEndEvent);
  //       }
  //     }, 50); // Adjust delay as needed
  
  //     return () => clearTimeout(timeoutId);
  //   }
  // }, [isZoomed]);

  const handleZoomToggle = () => {
    setIsZoomed(!isZoomed);
  };

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const ZoomButton = ({ onClickZoom, handleZoomToggle, currentImageUrl }) => {
  
    const handleClick = () => {
      onClickZoom(currentImageUrl);
      handleZoomToggle();
    };
  
    return (
      <button className="buttonZoom" onClick={handleClick}/>
    );
  };

  const ExtractImageIndexFromUrl = (urlString) => {
      const regex = /(\d+)\.jpg/;

      const match = urlString.match(regex);

      return match ? match[1] : null;
  }

  useEffect(() => {
    let visibleImageObserver = null;
  
    const checkVisibleImage = () => {
      const visibleImage = document.querySelector(
        'img[alt="Rotating object"][style*="display: block"]'
      );
  
      if (visibleImage) {
        const src = visibleImage.getAttribute('src');
        const imageIndex = ExtractImageIndexFromUrl(src);
        
        // console.log('current image index:', imageIndex, 'image to show:', imageToShow);
        // console.log('set viewer image to:', imageToShow !== currentImageToShow ? imageToShow : currentImageToShow);
        setCurrentImageToShow(imageIndex - 1);

        // Find the HD image or fallback to the non-HD version
        const currentImageHD = images360HD.find((imgObj) => {
          const regex = new RegExp(`${imageIndex}_full\\.jpg`);
          return regex.test(imgObj);
        }) || images360HD.find((imgObj) => {
          const regex = new RegExp(`${imageIndex}\\.jpg`);
          return regex.test(imgObj);
        });
  
        if (currentImageHD && currentImageHD !== currentHDImageUrl) {
          setCurrentImageUrl(src);
          setCurrentHDImageUrl(currentImageHD);
        }
      }
    };
  
    const observeVisibleImage = () => {
      // Continuously check for visible image
      const intervalId = setInterval(checkVisibleImage, 100);
  
      // Cleanup on unmount
      return () => {
        clearInterval(intervalId);
        if (visibleImageObserver) {
          visibleImageObserver.disconnect();
        }
      };
    };
  
    const observe360Container = () => {
      // Watch the container for DOM changes
      const parentElement = document.querySelector('.viewer360-container'); // Adjust selector as needed
  
      if (parentElement) {
        const mutationObserver = new MutationObserver(() => {
          // Whenever DOM changes occur, check the visible image
          checkVisibleImage();
        });
  
        mutationObserver.observe(parentElement, {
          childList: true,
          subtree: true,
        });
  
        // Cleanup observer on unmount
        return () => {
          mutationObserver.disconnect();
        };
      }
    };
  
    // Use both interval and MutationObserver for robustness
    observe360Container();
    return observeVisibleImage();
  }, [images360HD, currentHDImageUrl]);


  //Issue with system is 
  //1. The viewer is still displaying an image before we overwrite it => need to keep things in sync
  //2. If you carry on dragging the mouse, at some point the index goes back to zero and it reverts to that position
  //3. The index keeps increasing, so you need to drag back a bit before it starts rotating again
  //Need to force the index really
  //Why is it working with 0 as an index?
  useEffect(() => {
    if (!hasUserClicked) return;
    // Get all images within the viewer container
    const container = document.querySelector('.react-360-viewer-container');
    if (container) {
      const images = container.querySelectorAll('img[alt="Rotating object"]');
      const imagesArray = Array.from(images);

      setImageElements(imagesArray);

      // Find the initially visible image
      //const initialIndex = imagesArray.findIndex(img => img.style.display === 'block');
      //if (initialIndex !== -1) setCurrentIndex(initialIndex);
    }
  }, [hasUserClicked]);

  useEffect(() => {
    lastImageIndexRef.current = lastImageIndex; // Keep ref updated with latest value
    lastOverrideIndexRef.current = lastOverrideIndex; 
  }, [lastImageIndex, lastOverrideIndex]);

  // Sync state when parent updates imageToShow
  useEffect(() => {
    setCurrentImageToShow(imageToShow);
  }, [imageToShow]);

  useEffect(() => {
    window.addEventListener(`resize`, handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const preloadImages = async () => {
      const imagePromises = [];
      for (let i = 0; i < imagesCount; i++) {
        const img = new Image();
        img.src = `${imagesBaseUrl}/${i + 1}.jpg`; // Assuming images are named 1.jpg, 2.jpg, etc.
        imagePromises.push(new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve; // In case some images fail to load, continue
        }));
      }
      await Promise.all(imagePromises);
      //Wait 1 sec to avoid blinking images during 360 spin
      setTimeout(() => {
        setIsReadyToAutoplay(true);
      }, 1000);
    };
  
    preloadImages();
  }, [imagesBaseUrl]);

  //Array of images
  //const myImages = images; //Array.from({ length: 36 }, (_, i) => `https://exs-360-images.s3.eu-west-2.amazonaws.com/Armchair_teagan/${i + 1}.jpg`);

  const styles = {
    maxWidth: '900px',
    width: '800px'
  };

  //console.log('image to show, current:', imageToShow, currentImageToShow);
  return (
    <div 
      className="container360"
      style={{
        // width: Math.min(aspectRatio, 1) * 0.9 * Math.min(windowWidth, 1000),
        // height: Math.min(1 / aspectRatio, 1) * 0.9 * Math.min(windowWidth, 1000),
        // minWidth: Math.min(aspectRatio, 1) * 0.9 * Math.min(windowWidth, 1000), //Ensure min width during re-render to avoid empty space
        // minHeight: Math.min(1 / aspectRatio, 1) * 0.9 * Math.min(windowWidth, 1000),
        position: 'relative'
      }}
    >
      {/* <div className={`zoom-button-container ${isZoomed ? `expanded` : ''}`}>
        <ZoomButton
          onClickZoom={onClickZoom}
          handleZoomToggle={handleZoomToggle}
          currentImageUrl={currentImageUrl}
        />      
      </div> */}
      {!isZoomed ? (
        <div 
        className='react-360-viewer-container'
        style={{
          // width: Math.min(aspectRatio, 1) * 0.9 * Math.min(windowWidth, 1000),
          // height: Math.min(1 / aspectRatio, 1) * 0.9 * Math.min(windowWidth, 1000),
          Width: parentWidth, //Ensure min width during re-render to avoid empty space
          Height: parentHeight,
          transition: 'opacity 0.3s ease-in-out',
        }}
        //Double click disabled due to an issue with inner image zoom keeping ownership of the mouse and preventing
        //360 viewer to behave normally
        //onClick={handleDoubleClick}
        >
          <Suspense fallback={<div>Loading...</div>}>
            <Growm360Viewer
              className="react-360-viewer"
              //Force to re-render when we click on the same pointOfView button as the last one pressed if the user has rotated the object
              imagesCount={imagesCount}
              imagesBaseUrl={imagesBaseUrl}
              //TODO: Pass on file type in case we've got png
              imagesFiletype="jpg"
              autoplay={autoplayViewer && isReadyToAutoplay}
              autoplaySpeed={productSettings.growm360autoplaySpeed}
              imageInitialIndex={imageToShow}
              imageInitialIndexTrigger={forceUpdate}
              is180Pan={is180Pan}
              autoplayTarget={is180Pan? Math.round(imagesCount / 2) : 0} // Stop half-way through the pan for a 180 pan
              mouseDragSpeed={1}
              onPointerClick={toggleZoom}
              showRotationIconOnStartup={showRotationIconOnStartup}
              width={parentWidth}
              height={parentHeight}
              style={{
                Width: parentWidth, //Ensure min width during re-render to avoid empty space
                Height: parentHeight,
              }}
            />
          </Suspense>
        </div>) : (
        <div
          className={`inner-image-zoom-container ${isZoomed ? `expanded` : ''}`}
          style={{
            transition: 'opacity 0.3s ease-in-out',
          }}
          onClick={() => {console.log('image clicked');}}
          //onClick={toggleZoom}
          //onTouchEnd={toggleZoom}
          >
        <Suspense fallback={<div>Loading...</div>}>
          <InnerImageZoom
            className="innerImageZoom"
            src={currentImageUrl}
            zoomSrc={currentHDImageUrl}
            zoomType="hover"
            fullscreenOnMobile={false}
            hideCloseButton={true}
            moveType='drag'
            hideHint={true}
            afterZoomOut={toggleZoom}
            alt='zoom360'
            width={parentWidth}
            height={parentHeight}
            //style={{ width: '640px', height: 'auto', cursor: 'pointer', padding: 5 }}
          />
        </Suspense>
        </div>
      )
      }
    </div>
  );
};

export default ProductViewerComponent;
